export var parseUrl = function parseUrl(data, position) {
  var _data$split, _data$split$;
  if (!data) {
    return null;
  }
  return data == null ? void 0 : (_data$split = data.split('/p/')) == null ? void 0 : (_data$split$ = _data$split[1]) == null ? void 0 : _data$split$.split('/')[position];
};